import { Injectable } from '@angular/core';
var AnimateScrollService = /** @class */ (function () {
    function AnimateScrollService() {
        this._defaultStates = [];
    }
    AnimateScrollService.prototype.getDefaultStates = function () {
        return this._defaultStates;
    };
    AnimateScrollService.prototype.setDefaultStates = function (defaultStates) {
        this._defaultStates = defaultStates || this._defaultStates;
    };
    AnimateScrollService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    AnimateScrollService.ctorParameters = function () { return []; };
    return AnimateScrollService;
}());
export { AnimateScrollService };
//# sourceMappingURL=ng2-animate-scroll.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-animate-scroll/dist/src/ng2-animate-scroll.service.js
// module id = ./node_modules/ng2-animate-scroll/dist/src/ng2-animate-scroll.service.js
// module chunks = vendor